import { css, styled } from '@lichtblick/styled';
import { Colors, BorderRadius, Spacing } from '@lichtblick/theme';

export const WorkgroupCardContainer = styled.div<{ $isHighlighted?: boolean }>`
  background: ${Colors.white};

  border: 1px solid ${Colors.blue[20]};
  border-radius: ${BorderRadius.S};
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 8rem;
  max-width: 11.875rem;
  padding: ${Spacing.Xs};
  transition:
    background-color 0.3s ease,
    box-shadow 0.3s ease,
    border-color 0.3s ease;

  ${({ $isHighlighted }) =>
    $isHighlighted &&
    css`
      background-color: ${Colors.blue[50]};
      border: 2px solid ${Colors.blue['50']};
      box-shadow: 0 0 0 2px ${Colors.blue[100]};
    `}

  &:hover {
    background: ${({ $isHighlighted }) => ($isHighlighted ? Colors.blue[50] : Colors.blue[5])};
    cursor: pointer;
  }
`;

export const Top = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  height: 4.75rem;
  margin-bottom: 1rem;
  width: 9.875rem;

  > span {
    -webkit-box-orient: vertical;
    display: ${`-webkit-box`};
    height: 2.5rem;
    -webkit-line-clamp: 2;
    line-height: 140%;
    overflow: hidden;
  }
`;
